import script from "./ChartOTRFilteredPet.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartOTRFilteredPet.vue?vue&type=script&setup=true&lang=js"

import "./ChartOTRFilteredPet.vue?vue&type=style&index=0&id=40834fb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40834fb4"]])

export default __exports__